import * as api from "@/services/api";
import { serverErrorMessage } from "@/services/helpers";

export const clearRejectionQueue = async ({ commit, dispatch }) => {
  commit("clearRejections");
};

export const update = async ({ commit, dispatch }, payload) => {
  try {
    const response = await api.patch(`/rejects/${payload.id}`, payload);
    if (response.data.id) {
      commit("replaceReject", response.data);
      dispatch("getCounts");
      return response.data;
    }
    commit("ui/setSnackbar", { variant: "danger", title: "Error", message: "Problem updating reject" }, { root: true });
    return response.data;
  } catch (error) {
    commit("ui/setSnackbar", { variant: "danger", title: "Error", message: serverErrorMessage(error, "Problem updating reject") }, { root: true });
    return error;
  }
};

export const getCounts = async ({ commit }) => {
  try {
    const response = await api.get("/rejects/counts/all");
    commit("initCounts", response.data);
  } catch (error) {
    commit(
      "ui/setSnackbar",
      { variant: "danger", title: "Error", message: serverErrorMessage(error, "Unable to get rejection counts!") },
      { root: true },
    );
  }
};

export const fetchReject = async ({ commit, dispatch }, id) => {
  try {
    commit("setLoading", true);
    const response = await api.get(`/rejects/${id}`);
    if (response.data.id) {
      commit("replaceReject", response.data);
      return response.data;
    } else {
      commit("ui/setSnackbar", { variant: "danger", title: "Error", message: "Error fetching reject" }, { root: true });
    }
  } catch (error) {
    commit("ui/setSnackbar", { variant: "danger", title: "Error", message: serverErrorMessage(error, "Error fetching reject") }, { root: true });
  } finally {
    commit("setLoading", false);
  }
  return null;
};

export const restoreReject = async ({ commit, dispatch }, payload) => {
  try {
    const response = await api.patch(`/rejects/restore/${payload}`);
    if (response.data.message == "success") {
      commit("rejectRestored", payload);
    } else {
      commit("ui/setSnackbar", { variant: "danger", title: "Error", message: "Error trying to restore reject" }, { root: true });
    }
  } catch (error) {
    commit(
      "ui/setSnackbar",
      { variant: "danger", title: "Error", message: serverErrorMessage(error, "Error trying to restore reject") },
      { root: true },
    );
  }
};
